module.exports = __webpack_public_path__ + "img/hbdi-test.6c4b2a20.svg";